// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_disabledBTN__wY7mv {
  background: #b2bec3;
  color: #2d3436;
}

.button_primaryBTN__Zof0t {
  background: #74b9ff;
  color: #2d3436;
}
.button_primaryBTN__Zof0t:hover {
  background: #0984e3;
  color: #dfe6e9;
}
.button_secondaryBTN__Db55u {
  background: black;
  color: white;
}
.button_secondaryBTN__Db55u:hover {
  background: #35383a;
  color: white;
}
.button_successBTN__AzUSI {
  background: #22835f;
  color: white;
}
.button_successBTN__AzUSI:hover {
  background: #00b894;
  color: white;
}
.button_warningBTN__16k2O {
  background: #ffeaa7;
  color: #fdcb6e;
}
.button_warningBTN__16k2O:hover {
  background: #fdcb6e;
  color: white;
}
.button_dangerBTN__avORj {
  background: #ff7675;
  color: white;
}
.button_dangerBTN__avORj:hover {
  background: #d63031;
  color: #dfe6e9;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/button.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".disabledBTN {\n  background: #b2bec3;\n  color: #2d3436;\n}\n\n.primaryBTN {\n  background: #74b9ff;\n  color: #2d3436;\n}\n.primaryBTN:hover {\n  background: #0984e3;\n  color: #dfe6e9;\n}\n.secondaryBTN {\n  background: black;\n  color: white;\n}\n.secondaryBTN:hover {\n  background: #35383a;\n  color: white;\n}\n.successBTN {\n  background: #22835f;\n  color: white;\n}\n.successBTN:hover {\n  background: #00b894;\n  color: white;\n}\n.warningBTN {\n  background: #ffeaa7;\n  color: #fdcb6e;\n}\n.warningBTN:hover {\n  background: #fdcb6e;\n  color: white;\n}\n.dangerBTN {\n  background: #ff7675;\n  color: white;\n}\n.dangerBTN:hover {\n  background: #d63031;\n  color: #dfe6e9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabledBTN": `button_disabledBTN__wY7mv`,
	"primaryBTN": `button_primaryBTN__Zof0t`,
	"secondaryBTN": `button_secondaryBTN__Db55u`,
	"successBTN": `button_successBTN__AzUSI`,
	"warningBTN": `button_warningBTN__16k2O`,
	"dangerBTN": `button_dangerBTN__avORj`
};
export default ___CSS_LOADER_EXPORT___;
